export function render({ node, api }) {
  const root = document.createElement('div');

  const header = document.createElement('div');
  header.className = 'ew-node-header';
  header.dataset.ewDrag = 'true';
  header.dataset.ewSelect = 'true';
  header.dataset.ewLink = 'true';

  const title = document.createElement('span');
  title.textContent = node.props?.title || 'Text Input';

  const anchor = document.createElement('span');
  anchor.className = 'ew-link-anchor';
  anchor.dataset.ewLink = 'true';
  anchor.title = 'Link';

  header.append(title, anchor);

  const body = document.createElement('div');
  body.className = 'ew-node-body';

  const label = document.createElement('label');
  label.textContent = node.props?.label || 'Enter text';

  const input = document.createElement('input');
  input.type = 'text';
  input.placeholder = node.props?.placeholder || 'Type here';
  input.value = node.data?.value || '';

  const onInput = () => {
    api.setData({ value: input.value });
    api.emit('node:input', { id: node.id, field: 'value', value: input.value });
  };

  input.addEventListener('input', onInput);

  body.append(label, input);
  root.append(header, body);

  return {
    el: root,
    update: (next) => {
      title.textContent = next.props?.title || 'Text Input';
      label.textContent = next.props?.label || 'Enter text';
      input.placeholder = next.props?.placeholder || 'Type here';
      const nextValue = next.data?.value || '';
      if (input.value !== nextValue) input.value = nextValue;
    },
    cleanup: () => {
      input.removeEventListener('input', onInput);
    }
  };
}
